import Marquee from "react-fast-marquee";

const WORDS = ["MOVEMENT", "RECOVERY", "STRENGTH", "HEALING", "PERFORMANCE"];

export const EditorialMarquee = () => (
  <section data-testid="marquee-section" className="py-14 lg:py-20 bg-electric overflow-hidden">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {WORDS.map((w) => (
        <span key={w} className="flex items-center">
          <span className="font-display font-black text-6xl lg:text-8xl tracking-tighter text-white mx-6 lg:mx-10">{w}</span>
          <span className="w-4 h-4 lg:w-5 lg:h-5 mx-2 lg:mx-6 rotate-45 bg-navy inline-block" />
        </span>
      ))}
    </Marquee>
  </section>
);
